import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Form,
  FormGroup,
  Container,
  Row,
  Col,
} from "reactstrap";
import PropTypes from "prop-types";
import style from "./HistoryModal.scss";

function HistoryModal({ fromDate, changeDateHandler, toDate, displayDate, onSearch, modal, setModal }) {
  const [backdrop, setBackdrop] = useState(true);
  const [keyboard, setKeyboard] = useState(true);

  const toggle = () => setModal(!modal);

  const changeBackdrop = (e) => {
    let { value } = e.target;
    if (value !== "static") {
      value = JSON.parse(value);
    }
    setBackdrop(value);
  };

  const changeKeyboard = (e) => {
    setKeyboard(e.currentTarget.checked);
  };

  return (
    <div>
      <Modal className={style.modalContainer} isOpen={modal} toggle={toggle} backdrop={backdrop} keyboard={keyboard}>
        <ModalHeader className={style.modalHeader} toggle={toggle}>Seleccionar fechas</ModalHeader>
        <ModalBody className={style.modalBody}>
          {displayDate && (
            <span className={style.dateContainer}>
              <p>Rango de fechas máximo de 3 meses</p>
              <span>
                <Container fluid>
                  <Row>
                    <Col sm="12" md="5" lg="5" xl="5">
                      <Input
                        type="date"
                        name="fromDate"
                        id="fromDate"
                        value={fromDate}
                        onChange={changeDateHandler}
                      />
                    </Col>
                    <Col sm="12" md="5" lg="5" xl="5">
                      <Input
                        type="date"
                        name="toDate"
                        id="toDate"
                        value={toDate}
                        onChange={changeDateHandler}
                      />
                    </Col>
                  </Row>
                </Container>
              </span>
            </span>
          )}
        </ModalBody>
        <ModalFooter className={style.modalFooter}>
          <Button className={style.modalButtonSearch} onClick={onSearch}>
            Buscar
          </Button>{" "}
          <Button className={style.modalButtonCancel} onClick={toggle}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default HistoryModal;
